<text-box [view]="queryView"
          (onValueChange)="notifyValueChange($event)"></text-box>
